// Phase R0 — Slip Extractor design tokens (typed mirror).
//
// The handoff prototype styles inline; the real components do too
// (via CSS vars). This is the single TS source the ported
// components reference so a token is named once. It MIRRORS
// src/styles/slip-extractor.css (.se-root) exactly — seTokens.test.ts
// fails the build if they drift.
//
// Each value is also a `var(--se-*)` string so a component can use
// either the raw hex (rare) or, preferably, the CSS variable (so a
// future theme swap is one stylesheet edit).

export const SE = {
  // Surfaces
  surfacePage: "var(--se-surface-page)",
  surfaceCard: "var(--se-surface-card)",
  surfaceRecess: "var(--se-surface-recess)",
  surfaceRaised: "var(--se-surface-raised)",
  border: "var(--se-border)",
  borderBright: "var(--se-border-bright)",
  // Text
  text: "var(--se-text)",
  textSec: "var(--se-text-sec)",
  textMuted: "var(--se-text-muted)",
  textDim: "var(--se-text-dim)",
  // Reserved accents
  amber: "var(--se-amber)",
  amberBright: "var(--se-amber-bright)",
  keepGreen: "var(--se-keep-green)",
  keepGreenDim: "var(--se-keep-green-dim)",
  dropRed: "var(--se-drop-red)",
  dropRedDim: "var(--se-drop-red-dim)",
  conflictAmber: "var(--se-conflict-amber)",
  convergence: "var(--se-convergence)",
  convergenceGlow: "var(--se-convergence-glow)",
  convergenceCons: "var(--se-convergence-cons)",
  // Type
  fontDisplay: "var(--se-font-display)",
  fontBody: "var(--se-font-body)",
  fontMono: "var(--se-font-mono)",
} as const;

/** The raw committed hex/stack values (handoff §design-language).
 *  Kept distinct from the var() strings so the contract test can
 *  assert the actual palette didn't silently change. */
export const SE_RAW = {
  surfacePage: "#060606",
  surfaceCard: "#111111",
  surfaceRecess: "#0a0a0a",
  surfaceRaised: "#161616",
  border: "#1e1e1e",
  borderBright: "#2a2a2a",
  text: "#f0ede6",
  textSec: "#9b9790",
  textMuted: "#5c5a57",
  textDim: "#3a3835",
  amber: "#d4a843",
  amberBright: "#e8bc52",
  keepGreen: "#5dbf8a",
  dropRed: "#bf5d5d",
  conflictAmber: "#d4a843",
  convergence: "#b58ce8",
  convergenceCons: "#5dbf8a",
  fontDisplay: '"Playfair Display", Georgia, serif',
  fontBody: '"DM Sans", system-ui, -apple-system, sans-serif',
  fontMono: '"JetBrains Mono", ui-monospace, "SFMono-Regular", monospace',
} as const;

/** Root class to mount at the Slip Extractor page boundary (R8).
 *  Everything `--se-*` is scoped under it; zero Autopsy leakage. */
export const SE_ROOT_CLASS = "se-root";

export type SeToken = keyof typeof SE;
